import React from 'react';
import Grid from '@material-ui/core/Grid';
import {
  Card,
  CardContent,
  FormControl,
  FormControlLabel,
  FormLabel,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Table as MaterialTable,
  TableCell,
  TextareaAutosize,
  TextField,
  withStyles,
} from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableBody from '@material-ui/core/TableBody';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import CircularProgress from '@material-ui/core/CircularProgress';
import swal from '@sweetalert/with-react';
import axiosInstance, {
  emailValidation,
  EVENT_ID,
  getDialingCode,
  krMobileValidation,
  paragraphCounter,
  readFile,
  setScrollPosition,
  titleCounter,
  WEB_API,
  wordCounter,
} from '../constatns';
import { CountryList } from '../common/CountryList';
import FiguresUploadForm from '../components/FiguresUploadForm';
import Editor from '../components/Editor';
import Table from '../components/Table/Table';
import ConfirmButton from '../components/Button/ConfirmButton';
import { paperAction } from './FreePaperAction';

const styles = (theme) => ({
  root: {},
  formLabel: {
    fontSize: '0.8em',
    marginBottom: 8,
    marginTop: 10,
    '& span': {
      color: 'rgb(255, 0, 0)',
    },
  },
  asteriskMark: {
    color: 'rgb(255, 0, 0)',
  },
  title: {
    fontWeight: 'bold',
    color: theme.palette.primary.main,
    fontSize: '1.3em',
  },
  subtitle: {
    fontSize: '1em',
    fontWeight: 'bold',
  },
  body: {
    fontSize: '1em',
    '& span': {
      color: 'red',
      fontWeight: 'bold',
    },
  },
  paper: {
    '& .MuiTable-root': {
      borderTop: `2px solid ${theme.palette.primary.main}`,
    },
    '& .MuiTableCell-root': {
      padding: 4,
    },
    '& th.MuiTableCell-head': {
      textAlign: 'center',
      background: '#f8f8f8',
      padding: 16,
    },
    '& th': {
      background: '#f8f8f8',
      textAlign: 'center',
    },
  },
  card: {
    '& .MuiCardContent-root:last-child': {
      paddingBottom: theme.spacing(2),
    },
  },
  cardText: {
    paddingLeft: theme.spacing(3),
  },
  topCard: {
    '& .MuiCardContent-root': {
      borderTop: `2px solid ${theme.palette.primary.main}`,
    },
    '& .MuiTable-root': {
      border: '1px solid #ddd',
    },
    '& .MuiTableCell-root': {
      padding: 4,
    },
    '& th': {
      textAlign: 'center',
      background: '#f8f8f8',
      padding: 8,
      borderRight: '1px solid #ddd',
      '& span': {
        color: 'red',
        marginRight: 4,
      },
    },
  },
  inputLabelText: {
    fontSize: '1em',
    paddingBottom: '0.3em',
  },
  wordCounter: {
    backgroundColor: 'rgb(249, 249, 249)',
    borderBottom: '1px solid #c4c4c4',
    borderLeft: '1px solid #c4c4c4',
    borderRight: '1px solid #c4c4c4',
    borderBottomLeftRadius: '2px',
    borderBottomRightRadius: '2px',
    textAlign: 'right',
    padding: '0.2em 1em',
    fontWeight: 'bold',
    fontSize: '11px',
    color: '#4c4c4c',
  },
});

const TOPIC_LIST = [
  { value: 'Basic Research' },
  { value: 'Pediatric / Craniofacial' },
  { value: 'Hand & Upper Limb Reconstruction' },
  { value: 'Head and Neck Reconstruction' },
  { value: 'Breast / Body Reconstruction' },
  { value: 'Lower Limb Reconstruction' },
  { value: 'Lymphedema' },
  { value: 'Eyelid and Periocular Surgery' },
  { value: 'Rhinoplasty' },
  { value: 'Anti-aging Surgery' },
  { value: 'Facial Contouring Surgery' },
  { value: 'Aesthetic Breast Surgery' },
  { value: 'Body Contouring Surgery' },
  { value: 'Botox, Filler, Minimally Invasive Surgery' },
  { value: 'Laser' },
  { value: 'Fat and Stem Cell Therapy' },
  { value: 'Hair' },
  { value: 'Other Plastic Surgery' },
];

class FreePaperSubmissionForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      matches: window.matchMedia('(max-width:600px)').matches,
      loaded: false,
      isForeigner: '',
      isSubmitting: false,
      prepurposeContent: '',
      premethodsContent: '',
      preresultsContent: '',
      preconclusionContent: '',
      presentationType: '',
      abstractTopic: '',
      abstractTitle: '',
      abstractTitleCnt: 0,
      numOfInstitution: [{ id: 'num-grid-1', country: '', department: '', affiliation: '', city: '' }],
      setOfInstitution: 1,
      setOfAuthor: 1,
      numOfAuthor: [
        {
          id: 'num-author-1',
          firstName: '',
          lastName: '',
          ino1: '',
          ino2: '',
          country: '',
          category: '',
          email: '',
          countryCode: '',
          phoneNumber: '',
        },
      ],
      selectPresentingAuthor: '',
      selectCorrespondingAuthor: '',
      purposeContent: '',
      purposeParagraphCnt: 0,
      purposeWordCnt: 0,
      methodsContent: '',
      methodsParagraphCnt: 0,
      methodsWordCnt: 0,
      resultsContent: '',
      resultsParagraphCnt: 0,
      resultsWordCnt: 0,
      conclusionContent: '',
      conclusionParagraphCnt: 0,
      conclusionWordCnt: 0,
      figures: ['', '', '', ''],
      figuresMemo: ['', '', '', ''],
      setOfFigures: 4,
      isAgree1: '',
      isAgree2: '',
      isAdmin: this.props.isAdmin,
    };

    // console.log(props.isAdmin);

    this.setNumInstitution = this.setNumInstitution.bind(this);
    this.setNumAuthor = this.setNumAuthor.bind(this);
    this.setNumFigures = this.setNumFigures.bind(this);
    this.handleChangeInstitution = this.handleChangeInstitution.bind(this);
    this.handleChangeAuthor = this.handleChangeAuthor.bind(this);
    this.handleChangeOrder = this.handleChangeOrder.bind(this);
    this.handleChangeNum = this.handleChangeNum.bind(this);
    this.handleChangeAuthorInfo = this.handleChangeAuthorInfo.bind(this);
    this.delayEvent = this.delayEvent.bind(this);
    this.handleChangeImg = this.handleChangeImg.bind(this);
    this.clickUploadImg = this.clickUploadImg.bind(this);
    this.deleteImg = this.deleteImg.bind(this);
    this.handleFigureMemo = this.handleFigureMemo.bind(this);
  }

  componentDidMount() {
    setScrollPosition(0);
    this.setNumFigures();
    if (this.props.mode === 'modify') {
      this.getAbstractData(this.props.abstractId);
    } else {
      this.handleState('loaded', true);
    }
    this.getUserCountryInfo();
  }

  // static getDerivedStateFromProps(nextProps, prevState) {
  //   console.log(nextProps.mode);
  //   console.log(prevState.figuresMemo);
  //   if (nextProps.mode === 'modify' && prevState.figuresMemo) {
  //     if (
  //       prevState.figuresMemo[0] !== '' ||
  //       prevState.figuresMemo[1] !== '' ||
  //       prevState.figuresMemo[2] !== '' ||
  //       prevState.figuresMemo[3] !== ''
  //     ) {
  //       return { figuresMemo: prevState.figuresMemo };
  //     }
  //   } else {
  //     return null;
  //   }
  // }

  getAbstractData(abstractId) {
    if (this.props.infoData) {
      this.setData(this.props.infoData);
    } else {
      axiosInstance
        .get(`${WEB_API}/paper/info?eventId=${EVENT_ID}&paperId=${abstractId}`)
        .then((res) => {
          if (res.data.Item) {
            this.setData(res.data.Item);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }

  setData = (_data) => {
    for (const [key, value] of Object.entries(_data)) {
      // console.log(key + '의 값 : ' + value);
      if (key === 'abstractTitle') {
        this.setState({ [key]: value, [`${key}Cnt`]: titleCounter(value) });
      }
      if (key === 'purposeContent' || key === 'methodsContent' || key === 'resultsContent' || key === 'conclusionContent') {
        const splitArr = value.replace(/(<p>)/g, '').split('</p>');
        let paragraphArr = [];
        for (let i = 0; i < splitArr.length; i++) {
          if (splitArr[i] !== '' && splitArr[i] !== '&nbsp;' && splitArr[i].length > 0) {
            paragraphArr.push(splitArr[i]);
          }
        }
        const prefix = key.replace('Content', '');
        this.setState({ [key]: value, [`${prefix}WordCnt`]: wordCounter(value), [`${prefix}ParagraphCnt`]: paragraphArr.length }, () => {
          this.handleState('loaded', true);
          if (key === 'resultsContent') {
            // this.handleState('loaded', true);
            // console.log(this.state);
          }
        });
      }
      if (
        key === 'presentationType' ||
        key === 'abstractTopic' ||
        key === 'selectCorrespondingAuthor' ||
        key === 'selectPresentingAuthor' ||
        key === 'isAgree1' ||
        key === 'isAgree2' ||
        key === 'status'
      ) {
        this.setState(() => ({ [key]: value }));
      }
      if (key === 'numOfAuthor') {
        let authorArr = [];
        for (let i = 0; i < value.length; i++) {
          // console.log('num-author-' + (i + 1));
          authorArr.push({
            id: 'num-author-' + (i + 1),
            firstName: value[i].firstName,
            lastName: value[i].lastName,
            ino1: value[i].ino1,
            ino2: value[i].ino2,
            country: value[i].country,
            category: value[i].category,
            email: value[i].email,
            countryCode: value[i].countryCode,
            phoneNumber: value[i].phoneNumber,
          });
        }
        this.setState({ setOfAuthor: value.length, [key]: authorArr });
      }
      if (key === 'numOfInstitution') {
        let institutionArr = [];
        for (let i = 0; i < value.length; i++) {
          institutionArr.push({
            id: 'num-grid-' + (i + 1),
            country: value[i].country,
            department: value[i].department,
            affiliation: value[i].affiliation,
            city: value[i].city,
          });
        }
        this.setState({ setOfInstitution: value.length, [key]: institutionArr });
      }
      if (key === 'figures1' || key === 'figures2' || key === 'figures3' || key === 'figures4') {
        let buff = this.state.figures;
        for (let i = 0; i < this.state.figures.length; i++) {
          if (Number(key.substr(7)) - 1 === i) {
            buff[i] = value;
          }
        }
        this.setState(() => ({ figures: buff }));
      }
      if (key === 'figuresMemo1' || key === 'figuresMemo2' || key === 'figuresMemo3' || key === 'figuresMemo4') {
        let _buff = this.state.figuresMemo;
        for (let i = 0; i < this.state.figuresMemo.length; i++) {
          if (Number(key.substr(11)) - 1 === i) {
            _buff[i] = value;
          }
        }
        this.setState(() => ({ figuresMemo: _buff }));
      }
      if (key === 'memo' && this.props.mode === 'modify') {
        this.setState({ memo: value });
      }
    }
  };

  handleChange(e, type) {
    this.setState({ [type]: e.target.value });
  }

  handleState = (type, value) => {
    this.setState((prevState) => ({ [type]: value }));
  };

  getUserCountryInfo() {
    const country = sessionStorage.getItem('_in_country');
    if (country === 'Korea, Republic of') {
      this.setState({ isForeigner: 'N' });
    } else {
      this.setState({ isForeigner: 'Y' });
    }
  }

  setNumInstitution(e) {
    this.handleState('numOfInstitution', [{ id: 'num-grid-1', affiliation: '' }]);
    const num = document.getElementById('num-institution').value;
    if (this.state.numOfInstitution.length > Number(num)) {
      const newItem = this.state.numOfInstitution.splice(-this.state.numOfInstitution.length, Number(num));
      this.handleState('numOfInstitution', newItem);
    } else {
      let addArr = [];
      for (let i = 1; i < Number(num) - this.state.numOfInstitution.length + 1; i++) {
        const max = Number(this.getMax(this.state.numOfInstitution, 'num-grid-'));
        addArr.push({ id: 'num-grid-' + (i + max), affiliation: '', country: '', department: '', city: '' });
      }
      this.handleState('numOfInstitution', this.state.numOfInstitution.concat(addArr));
    }
  }

  setNumAuthor(e) {
    this.handleState('numOfAuthor', [{ id: 'num-author-1', firstName: '', lastName: '' }]);
    const num = document.getElementById('num-author').value;
    if (this.state.numOfAuthor.length > Number(num)) {
      const newItem = this.state.numOfAuthor.splice(-this.state.numOfAuthor.length, Number(num));
      this.handleState('numOfAuthor', newItem);
    } else {
      let addArr = [];
      for (let i = 1; i < Number(num) - this.state.numOfAuthor.length + 1; i++) {
        const max = Number(this.getMax(this.state.numOfAuthor, 'num-author-'));
        addArr.push({
          id: 'num-author-' + (i + max),
          firstName: '',
          lastName: '',
          ino1: '',
          ino2: '',
          country: '',
          category: '',
          email: '',
          countryCode: '',
          phoneNumber: '',
        });
      }
      this.handleState('numOfAuthor', this.state.numOfAuthor.concat(addArr));
    }
  }

  setNumFigures() {
    let buff = [];
    let _buff = [];
    for (let i = 0; i < Number(this.state.setOfFigures); i++) {
      buff.push('');
      _buff.push('');
    }
    this.handleState('figures', buff);
    this.handleState('figuresMemo', _buff);
  }

  getMax(data, _rep) {
    return data.reduce(
      (max, p) => (p.id.replace(_rep, '') > max.replace(_rep, '') ? p.id.replace(_rep, '') : max),
      data[0].id.replace(_rep, ''),
    );
  }

  addInstitution() {
    return this.state.numOfInstitution.map((v, i) => {
      const idx = this.state.numOfInstitution.findIndex((item) => item.id === v.id);
      return (
        <Grid
          item
          xs={12}
          style={
            this.props.isAdmin
              ? navigator.userAgent.indexOf('Trident') !== -1
                ? { padding: 20, minWidth: '960px' }
                : { padding: 20 }
              : { padding: 0 }
          }
          key={i}
          id={v.id}
        >
          <Card variant="outlined" className={this.props.classes.topCard}>
            <CardContent>
              <Grid
                container
                direction={'row'}
                justifyContent={'flex-start'}
                alignItems={'center'}
                spacing={2}
                style={{ paddingBottom: 20 }}
              >
                <Grid item>
                  <div className={this.props.classes.subtitle}>Institution #{1 + i}</div>
                </Grid>
                <Grid item>
                  {i > 0 ? (
                    <Button color="secondary" variant={'outlined'} disableElevation onClick={(e) => this.deleteInstitution(v.id)}>
                      Delete
                    </Button>
                  ) : null}
                </Grid>
              </Grid>
              <Grid container direction={'row'} justifyContent={'space-evenly'} spacing={2}>
                <Grid item md={6} xs={12}>
                  <FormControl variant="outlined" fullWidth size={'small'} className={this.props.classes.formControl}>
                    <FormLabel component="legend" className={this.props.classes.formLabel}>
                      <span>*</span> Country
                    </FormLabel>
                    <Select
                      required
                      displayEmpty
                      labelId="country-label"
                      value={this.state.numOfInstitution[idx].country ? this.state.numOfInstitution[idx].country : ''}
                      onChange={(e) => this.handleChangeInstitution(e, idx, 'country')}
                    >
                      <MenuItem value={''}>Select</MenuItem>
                      {CountryList.map((country, cIdx) => {
                        return (
                          <MenuItem value={country.name} key={`country-select-item-${cIdx}`}>
                            {country.name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item md={6} xs={12}>
                  <FormLabel component="legend" className={this.props.classes.formLabel}>
                    <span>*</span> Department
                  </FormLabel>
                  <TextField
                    required
                    fullWidth
                    variant="outlined"
                    size="small"
                    value={this.state.numOfInstitution[idx].department}
                    onChange={(e) => this.handleChangeInstitution(e, idx, 'department')}
                  />
                </Grid>
              </Grid>
              <Grid container direction={'row'} justifyContent={'space-evenly'} spacing={2}>
                <Grid item md={6} xs={12}>
                  <FormLabel component="legend" className={this.props.classes.formLabel}>
                    <span>*</span> Affiliation
                  </FormLabel>
                  <TextField
                    required
                    fullWidth
                    variant="outlined"
                    size="small"
                    value={this.state.numOfInstitution[idx].affiliation}
                    onChange={(e) => this.handleChangeInstitution(e, idx, 'affiliation')}
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <FormLabel component="legend" className={this.props.classes.formLabel}>
                    <span>*</span> City/State
                  </FormLabel>
                  <TextField
                    required
                    fullWidth
                    variant="outlined"
                    size="small"
                    value={this.state.numOfInstitution[idx].city}
                    onChange={(e) => this.handleChangeInstitution(e, idx, 'city')}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      );
    });
  }

  addAuthor() {
    return (
      <Grid
        item
        xs={12}
        style={
          this.props.isAdmin
            ? navigator.userAgent.indexOf('Trident') !== -1
              ? { padding: 20, minWidth: '960px' }
              : { padding: 20 }
            : { padding: 0 }
        }
      >
        <Paper variant={'outlined'} className={this.props.classes.paper}>
          <TableContainer>
            <MaterialTable aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Order</TableCell>
                  <TableCell>
                    <span className={this.props.classes.asteriskMark}>*</span> First Name
                  </TableCell>
                  <TableCell>
                    <span className={this.props.classes.asteriskMark}>*</span> Last Name
                  </TableCell>
                  <TableCell width={'17%'}>
                    <span className={this.props.classes.asteriskMark}>*</span> Institution No.
                  </TableCell>
                  <TableCell>
                    <span className={this.props.classes.asteriskMark}>*</span> Presenting Author
                  </TableCell>
                  <TableCell width={'15%'}>
                    <span className={this.props.classes.asteriskMark}>*</span> Corresponding Author
                  </TableCell>
                  <TableCell>Author Order</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {this.state.numOfAuthor.map((item, i) => {
                  return (
                    <TableRow key={item.id}>
                      <TableCell align="center">{i + 1}</TableCell>
                      <TableCell align="center">
                        <TextField
                          required
                          fullWidth
                          margin={'dense'}
                          variant="outlined"
                          size="small"
                          value={this.state.numOfAuthor[i].firstName}
                          onChange={(e) => this.handleChangeAuthor(e, i, 'firstName')}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <TextField
                          required
                          margin={'dense'}
                          fullWidth
                          variant="outlined"
                          size="small"
                          value={this.state.numOfAuthor[i].lastName}
                          onChange={(e) => this.handleChangeAuthorLastName(e, i, 'lastName')}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <Grid container spacing={1}>
                          <Grid item xs={6}>
                            <FormControl variant="outlined" size="small" fullWidth>
                              <Select
                                id={'sel-institution-1'}
                                displayEmpty
                                value={this.state.numOfAuthor[i]['ino1'] ? this.state.numOfAuthor[i]['ino1'] : ''}
                                onChange={(e) => {
                                  this.handleChangeAuthor(e, i, 'ino1');
                                }}
                                style={{
                                  fontSize: '0.9em',
                                }}
                              >
                                <MenuItem value={''}>Select</MenuItem>
                                {this.state.numOfInstitution.map((a, idx) => {
                                  return (
                                    <MenuItem key={a.id} value={a.id}>
                                      {1 + idx}
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                            </FormControl>
                          </Grid>
                          <Grid item xs={6}>
                            <FormControl variant="outlined" size="small" fullWidth disabled={this.state.numOfInstitution.length <= 1}>
                              <Select
                                id={'sel-institution-2'}
                                displayEmpty
                                value={this.state.numOfAuthor[i]['ino2'] ? this.state.numOfAuthor[i]['ino2'] : ''}
                                onChange={(e) => {
                                  this.handleChangeAuthor(e, i, 'ino2');
                                }}
                                style={{
                                  fontSize: '0.9em',
                                }}
                              >
                                <MenuItem value={''}>Select</MenuItem>
                                {this.state.numOfInstitution.map((a, idx) => {
                                  return (
                                    <MenuItem key={a.id} value={a.id}>
                                      {1 + idx}
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                            </FormControl>
                          </Grid>
                        </Grid>
                      </TableCell>
                      <TableCell align="center">
                        <Radio
                          checked={this.state.selectPresentingAuthor === item.id}
                          onChange={(e) => {
                            this.setState(
                              (prev) => ({ selectPresentingAuthor: item.id }),
                              () => {
                                this.handleChangeAuthorInfo(
                                  { target: { value: this.state.numOfInstitution[0].country } },
                                  'Presenting',
                                  'country',
                                );
                              },
                            );
                          }}
                          value={item.id}
                          name="radio-selectPresentingAuthor"
                          id="select-presenting-author"
                        />
                      </TableCell>
                      <TableCell align="center">
                        <Radio
                          checked={this.state.selectCorrespondingAuthor === item.id}
                          onChange={(e) => {
                            this.setState(
                              (prev) => ({ selectCorrespondingAuthor: item.id }),
                              () => {
                                this.handleChangeAuthorInfo(
                                  { target: { value: this.state.numOfInstitution[0].country } },
                                  'Corresponding',
                                  'country',
                                );
                              },
                            );
                          }}
                          value={item.id}
                          name="radio-selectCorrespondingAuthor"
                          id="select-corresponding-author"
                        />
                      </TableCell>
                      <TableCell align="center">
                        <IconButton onClick={(e) => this.handleChangeOrder('up', i)}>
                          <ArrowDropUpIcon />
                        </IconButton>
                        <IconButton onClick={(e) => this.handleChangeOrder('down', i)}>
                          <ArrowDropDownIcon />
                        </IconButton>
                        {i > 0 ? (
                          <IconButton onClick={(e) => this.deleteAuthor(item.id)}>
                            <DeleteForeverIcon />
                          </IconButton>
                        ) : null}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </MaterialTable>
          </TableContainer>
        </Paper>
      </Grid>
    );
    // })
  }

  deleteInstitution(_id) {
    const idx = this.state.numOfInstitution.findIndex((val) => val.id === _id);
    const items = this.state.numOfInstitution;
    items.splice(idx, 1);
    this.handleState('numOfInstitution', items);
    this.handleState('setOfInstitution', this.state.setOfInstitution - 1);
  }

  deleteAuthor(_id) {
    const idx = this.state.numOfAuthor.findIndex((val) => val.id === _id);
    const items = this.state.numOfAuthor;
    items.splice(idx, 1);

    if (this.state.selectPresentingAuthor && this.state.selectPresentingAuthor.id && _id === this.state.selectPresentingAuthor.id) {
      this.handleState('selectPresentingAuthor', {});
    }
    if (this.state.selectCorrespondingAuthor && _id === this.state.selectCorrespondingAuthor) {
      this.handleState('selectCorrespondingAuthor', {});
    }
    this.handleState('numOfAuthor', items);
    this.handleState('setOfAuthor', this.state.setOfAuthor - 1);
  }

  handleChangeInstitution(e, idx, type) {
    const val = e.target.value;
    const item = this.state.numOfInstitution[idx];
    item[type] = val;
    const items = this.state.numOfInstitution;
    items[idx] = item;
    this.handleState('numOfInstitution', items);
    // if (type === 'country' && idx === 0) {

    // }
  }
  // handleChangeAuthor(e, i, 'lastName')}
  handleChangeAuthor(e, idx, type) {
    const val = e.target.value;
    const item = this.state.numOfAuthor[idx];
    item[type] = val;
    const items = this.state.numOfAuthor;
    items[idx] = item;
    this.handleState('numOfAuthor', items);
  }

  handleChangeAuthorLastName(e, idx, type) {
    const val = this.capitalizeFirstLetter(e.target.value);
    const item = this.state.numOfAuthor[idx];
    item[type] = val;
    const items = this.state.numOfAuthor;
    items[idx] = item;
    this.handleState('numOfAuthor', items);
  }

  capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  handleChangeOrder(type, idx) {
    const items = this.state.numOfAuthor;
    if (type === 'up') {
      if (idx > 0) {
        const target = items.splice(idx, 1)[0];
        items.splice(idx - 1, 0, target);
      }
    } else {
      if (idx < items.length - 1) {
        const target = items.splice(idx, 1)[0];
        items.splice(idx + 1, 0, target);
      }
    }
    this.handleState('numOfAuthor', items);
  }

  handleChangeTitle = (e) => {
    if (titleCounter(e.target.value) <= 30) {
      this.handleState('abstractTitle', e.target.value);
      this.handleState('abstractTitleCnt', titleCounter(e.target.value));
    } else {
      this.handleState('abstractTitle', e.target.value.substring(0, e.target.value.length - 1));
      swal('Title cannot over 30 words');
      return false;
    }
  };

  getAuthorInfo(authorType, type) {
    let val = '';
    this.state.numOfAuthor.forEach((item) => {
      if (item.id === this.state[`select${authorType}Author`]) {
        val = item[type];
      }
    });
    return val;
  }

  handleChangeAuthorInfo(e, authorType, type) {
    // console.log(e);
    // console.log(authorType);
    // console.log(type);
    // console.log(this.state.numOfAuthor);
    // console.log(this.state[`select` + authorType + `Author`]);
    for (let i = 0; i < this.state.numOfAuthor.length; i++) {
      if (this.state.numOfAuthor[i].id === this.state[`select` + authorType + `Author`]) {
        if (type === 'country') {
          this.handleChangeAuthorCountry(e, i, type);
        } else {
          this.handleChangeAuthor(e, i, type);
        }
      }
    }
  }

  handleChangeAuthorCountry(e, idx, type) {
    const val = e.target.value;
    const item = this.state.numOfAuthor[idx];
    item[type] = val;
    item.countryCode = getDialingCode(val);
    const items = this.state.numOfAuthor;
    items[idx] = item;
    this.handleState('numOfAuthor', items);
  }

  handleChangeNum(e, authorType, type) {
    const re = /^[0-9\b]+$/;
    if (e.target.value === '' || re.test(e.target.value)) {
      for (let i = 0; i < this.state.numOfAuthor.length; i++) {
        if (this.state.numOfAuthor[i].id === this.state[`select` + authorType + `Author`]) {
          this.handleChangeAuthor(e, i, type);
        }
      }
    }
  }

  async delayEvent(event, editor, type) {
    let data = editor.getData();

    if (data.includes('<pre>')) {
      data = data.replace(/<pre>/gi, '<span>');
      data = data.replace(/<\/pre>/gi, '</span>');
    }

    const abstractArr = ['purpose', 'methods', 'results', 'conclusion'];

    //단어 수 계산
    let buffCnt = wordCounter(data);

    for (let i = 0; i < abstractArr.length; i++) {
      if (abstractArr[i] !== type) {
        buffCnt += this.state[abstractArr[i] + `WordCnt`];
      }
    }
    if (buffCnt > 250) {
      swal('Word cannot over 250 words');
      this.handleState(`${type}Content`, this.state[`pre${type}Content`]);
      if (editor) {
        editor.setData(this.state[`pre${type}Content`]);
      }
      return false;
    }

    this.handleState(`pre${type}Content`, data);
    this.handleState(`${type}Content`, data);
    this.handleState(`${type}ParagraphCnt`, paragraphCounter(data));
    this.handleState(`${type}WordCnt`, wordCounter(data));
  }

  //이미지 첨부 버튼 클릭
  clickUploadImg(event, type) {
    event.preventDefault();
    document.getElementById(`${type}`).click();
  }

  //input 태그 -> 실제로 이미지 바꾸는 코드
  handleChangeImg = async (event, type) => {
    if (event.target.files[0]) {
      let buff = this.state.figures;
      const targetFile = event.target.files[0];
      await readFile(targetFile, -1).then((file) => {
        for (let i = 0; i < buff.length; i++) {
          if (Number(type) === i) {
            buff[i] = targetFile;
          }
        }
        this.setState({ figures: buff });
      });
    }
  };

  deleteImg(_id, delItem) {
    const items = this.state.figures;
    const memoArr = this.state.figuresMemo;
    if (delItem.size) {
      items.splice(_id, 1, '');
      memoArr.splice(_id, 1, '');
      this.handleState('figures', items);
      this.handleState('figuresMemo', memoArr);
    } else {
      swal({
        text: 'Are you sure to delete image?',
        buttons: true,
      }).then((willDelete) => {
        if (willDelete) {
          axiosInstance
            .post(`${WEB_API}/paper/img`, {
              evt: EVENT_ID,
              paperId: this.props.abstractId,
              // paperId: window.location.hash.split('/')[3].substr(7),
              delKey: 'figures' + (_id + 1),
              delPath: this.state.figures[_id].path,
            })
            .then((res) => {
              items.splice(_id, 1, '');
              memoArr.splice(_id, 1, '');
              this.handleState('figures', items);
              this.handleState('figuresMemo', memoArr);
            })
            .catch((err) => {
              console.error(err);
            });
        }
      });
    }
  }

  handleFigureMemo = (event, idx) => {
    let buff = this.state.figuresMemo;
    const val = event.target.value;
    for (let i = 0; i < buff.length; i++) {
      if (Number(idx) === i) {
        buff[i] = val;
      }
    }
    this.setState({ figuresMemo: buff });
  };

  checkBlank() {
    let blankItem = '';
    let checkInstitutionArr = [];
    let checkAuthorArr = [];

    this.state.numOfInstitution.forEach((item) => {
      //institution의 각 항목이 빈칸인지 아닌지 확인
      if (item.country !== '' && item.city !== '' && item.department !== '' && item.affiliation !== '') {
        checkInstitutionArr.push(true);
      }
    });
    // console.log(checkInstitutionArr);

    //author항목 확인
    // console.log(this.state.selectPresentingAuthor);
    // console.log(this.state.selectCorrespondingAuthor);
    for (let idx = 0; idx < this.state.numOfAuthor.length; idx++) {
      if (
        this.state.numOfAuthor[idx].id === this.state.selectPresentingAuthor ||
        this.state.numOfAuthor[idx].id === this.state.selectCorrespondingAuthor
      ) {
        // Presenting Author나 Corresponding Author 항목 유효성검사
        if (
          this.state.numOfAuthor[idx].firstName !== '' &&
          this.state.numOfAuthor[idx].lastName !== '' &&
          this.state.numOfAuthor[idx].ino1 !== ''
        ) {
          checkAuthorArr.push(true);
        }
      } else {
        // Presenting Author나 Corresponding Author가 아닌 Author 항목 유효성검사
        if (
          this.state.numOfAuthor[idx].firstName !== '' &&
          this.state.numOfAuthor[idx].lastName !== '' &&
          this.state.numOfAuthor[idx].ino1 !== ''
        ) {
          checkAuthorArr.push(true);
        }
      }
    }
    // console.log(checkAuthorArr);

    //blankItem(alertMsg1, alertMsg2, focusElemId)
    if (this.state.presentationType === '') {
      blankItem = 'choose/presentation type/ptype';
    } else if (this.state.abstractTopic === '') {
      blankItem = 'select/abstract topic/atopic';
    } else if (this.state.abstractTitle === '' || this.state.abstractTitleCnt < 1) {
      blankItem = 'input/abstract title/abstract-title-input';
    } else if (checkInstitutionArr.length !== this.state.numOfInstitution.length) {
      blankItem = 'input/all items of institution/num-institution';
    } else if (this.state.numOfAuthor.length !== checkAuthorArr.length) {
      blankItem = 'input/all items of author information/num-author';
    } else {
      if (this.state.selectPresentingAuthor === '' && this.state.selectCorrespondingAuthor === '')
        blankItem = 'choose/presenting author and corresponding author/select-presenting-author';
      else if (this.state.selectPresentingAuthor === '') blankItem = 'choose/presenting author/select-presenting-author';
      else if (this.state.selectCorrespondingAuthor === '') blankItem = 'choose/corresponding author/select-corresponding-author';
      // * 병원 방화벽 문제로 해당 기능 사용 불가능 case -> 필수항목 제거
      // else if (this.state.purposeContent === '' || this.state.purposeWordCnt < 1) blankItem = 'input/purpose content';
      // else if (this.state.methodsContent === '' || this.state.methodsWordCnt < 1) blankItem = 'input/methods content';
      // else if (this.state.resultsContent === '' || this.state.resultsWordCnt < 1) blankItem = 'input/results content';
      // else if (this.state.conclusionContent === '' || this.state.conclusionWordCnt < 1) blankItem = 'input/conclusion content';
      else if (this.state.isAgree1 === '' || this.state.isAgree2 === '') blankItem = 'check/agreement/is-agree-1';
      else {
        this.state.numOfAuthor.forEach((author) => {
          if (author.id === this.state.selectPresentingAuthor) {
            if (author.country === '') blankItem = "select/presenting author's country/presenting-country";
            if (author.category === '') blankItem = "choose/presenting author's category/presenting-category";
            if (author.email === '') blankItem = "input/presenting author's email/presenting-email";
            if (author.countryCode === '') blankItem = "input/presenting author's country code/presenting-country-code-input";
            if (author.phoneNumber === '') blankItem = "input/presenting author's phone number/presenting-phone-number-input";
          } else if (author.id === this.state.selectCorrespondingAuthor) {
            if (author.country === '') blankItem = "select/corresponding author's country/corresponding-country";
            if (author.category === '') blankItem = "choose/corresponding author's category/corresponding-category";
            if (author.email === '') blankItem = "input/corresponding author's email/corresponding-email";
            if (author.countryCode === '') blankItem = "input/corresponding author's country code/corresponding-country-code-input";
            if (author.phoneNumber === '') blankItem = "input/corresponding author's phone number/corresponding-phone-number-input";
          }
        });
      }
    }
    // console.log(blankItem);
    return blankItem;
  }

  checkEmailValidation = () => {
    let isValid = '';
    if (this.state.selectPresentingAuthor === this.state.selectCorrespondingAuthor) {
      for (let i = 0; i < this.state.numOfAuthor.length; i++) {
        if (this.state.numOfAuthor[i].id === this.state.selectPresentingAuthor) {
          if (!emailValidation(this.state.numOfAuthor[i].email)) {
            isValid = 'presenting-email';
          }
        }
      }
    } else {
      for (let i = 0; i < this.state.numOfAuthor.length; i++) {
        if (this.state.numOfAuthor[i].id === this.state.selectPresentingAuthor) {
          if (this.state.numOfAuthor[i].email !== '' && !emailValidation(this.state.numOfAuthor[i].email)) {
            isValid = 'presenting-email';
          }
        }
        if (this.state.numOfAuthor[i].id === this.state.selectCorrespondingAuthor) {
          if (this.state.numOfAuthor[i].email !== '' && !emailValidation(this.state.numOfAuthor[i].email)) {
            isValid = 'corresponding-email';
          }
        }
      }
    }
    return isValid;
  };

  checkMobileValidation = () => {
    let isValid = '';
    if (this.state.selectPresentingAuthor === this.state.selectCorrespondingAuthor) {
      for (let i = 0; i < this.state.numOfAuthor.length; i++) {
        if (this.state.numOfAuthor[i].id === this.state.selectPresentingAuthor) {
          if (this.state.numOfAuthor[i].country === 'Korea, Republic of') {
            //1.한국이면 한국폰번호 정규식일치하는지
            if (!krMobileValidation(this.state.numOfAuthor[i].phoneNumber)) {
              isValid = 'presenting-phone-number-input';
            }
          } else {
            //2.한국외 국가면 7자 이상의 숫자인지
            if (!/(\d{7,})/gi.test(this.state.numOfAuthor[i].phoneNumber)) {
              isValid = 'presenting-phone-number-input';
            }
          }
        }
      }
    } else {
      for (let i = 0; i < this.state.numOfAuthor.length; i++) {
        if (this.state.numOfAuthor[i].id === this.state.selectPresentingAuthor) {
          if (this.state.numOfAuthor[i].phoneNumber !== '') {
            if (this.state.numOfAuthor[i].country === 'Korea, Republic of') {
              if (!krMobileValidation(this.state.numOfAuthor[i].phoneNumber)) {
                isValid = 'presenting-phone-number-input';
              }
            } else {
              if (!/(\d{7,})/gi.test(this.state.numOfAuthor[i].phoneNumber)) {
                isValid = 'presenting-phone-number-input';
              }
            }
          }
        }
        if (this.state.numOfAuthor[i].id === this.state.selectCorrespondingAuthor) {
          if (this.state.numOfAuthor[i].phoneNumber !== '') {
            if (this.state.numOfAuthor[i].country === 'Korea, Republic of') {
              if (!krMobileValidation(this.state.numOfAuthor[i].phoneNumber)) {
                isValid = 'corresponding-phone-number-input';
              }
            } else {
              if (!/(\d{7,})/gi.test(this.state.numOfAuthor[i].phoneNumber)) {
                isValid = 'corresponding-phone-number-input';
              }
            }
          }
        }
      }
    }
    return isValid;
  };

  onSubmit() {
    if (this.checkBlank() !== '') {
      swal(`Please ${this.checkBlank().split('/')[0]} ${this.checkBlank().split('/')[1]}.`).then(() => {
        if (this.checkBlank().split('/')[2]) {
          document.getElementById(this.checkBlank().split('/')[2]).focus();
          if (this.checkBlank().split('/')[2].indexOf('ptype') !== 1 || this.checkBlank().split('/')[2].indexOf('abstract') !== 1) {
            setScrollPosition(800);
          } else if (this.checkBlank().split('/')[2].indexOf('num-institution') !== 1) {
            setScrollPosition(1250);
          } else if (this.checkBlank().split('/')[2].indexOf('num-author') !== 1) {
            setScrollPosition(1600);
          } else if (this.checkBlank().split('/')[2].indexOf('presenting') !== 1) {
            setScrollPosition(1900);
          } else if (this.checkBlank().split('/')[2].indexOf('corresponding') !== 1) {
            setScrollPosition(2300);
          } else if (this.checkBlank().split('/')[2].indexOf('agree')) {
            setScrollPosition(document.getElementById('subroot').scrollHeight);
          }
        }

        // * 병원 방화벽 문제로 해당 기능 사용 불가능 case -> 필수항목 제거

        // else {
        //   if (this.checkBlank().split('/')[1].indexOf('purpose')) {
        //     setScrollPosition(2800);
        //   } else if (this.checkBlank().split('/')[1].indexOf('methods')) {
        //     setScrollPosition(3100);
        //   } else if (this.checkBlank().split('/')[1].indexOf('results')) {
        //     setScrollPosition(3350);
        //   } else if (this.checkBlank().split('/')[1].indexOf('conclusion')) {
        //     setScrollPosition(3600);
        //   }
        // }
      });
      return;
    }
    if (this.checkEmailValidation() !== '') {
      swal('Email address is not valid').then(() => {
        document.getElementById(this.checkEmailValidation()).focus();
      });
      return;
    }
    if (this.checkMobileValidation() !== '') {
      swal('Mobile number is not valid').then(() => {
        document.getElementById(this.checkMobileValidation()).focus();
      });
      return;
    }
    // if (this.state.isAgree1 === 'disagree' || this.state.isAgree2 === 'disagree') {
    //   swal('You must agree to submit').then(() => {
    //     if (this.state.isAgree1 === 'disagree') {
    //       setScrollPosition(document.getElementById('subroot').scrollHeight);
    //       document.getElementById('is-agree-1').focus();
    //     } else {
    //       setScrollPosition(document.getElementById('subroot').scrollHeight);
    //       document.getElementById('is-agree-2').focus();
    //     }
    //   });
    //   return;
    // }

    this.setState({ isSubmitting: true });
    paperAction(this.state, this.props.mode, this.props.abstractId)
      .then((result) => {
        if (this.props.mode === 'modify') {
          if (this.props.isRegister) {
            swal('Your submission will be temporarily saved.', {
              icon: 'success',
            }).then(() => {
              this.props.handleState('paperId', result.data.Attributes.id);
              this.props.handleState('data', result.data.Attributes);
              this.props.handleState('formState', 'confirm');
              this.setStateInitialize();
            });
          } else if (this.props.isMypage) {
            const msg =
              this.state.status && this.state.status === 'Complete'
                ? 'Your submission is modified successfully.'
                : 'Your submission will be temporarily saved.';
            swal(msg, {
              icon: 'success',
            }).then(() => {
              this.props.handleState('paperId', result.data.Attributes.id);
              this.props.handleState('paperInfo', result.data.Attributes);
              this.props.handleState('showReview', true);
              this.props.handleState('showMod', false);
            });
          } else {
            swal('Your submission is modified successfully.', {
              icon: 'success',
            }).then(() => {
              this.closeWindow();
            });
          }
        } else {
          // axiosInstance.post(`${WEB_API}/paper/paperSubmitEmail?evt=${EVENT_ID}&paperId=${paperId}`).then(() => {});
          swal('Your submission will be temporarily saved.', {
            icon: 'success',
          }).then(() => {
            if (this.props.handleState) {
              this.props.handleState('paperId', result.data.Attributes.id);
              this.props.handleState('data', result.data.Attributes);
              this.props.handleState('formState', 'confirm');
            }
            this.setStateInitialize();
          });
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.setState({ isSubmitting: false });
      });
  }

  closeWindow() {
    if (this.props.isPop) {
      this.props.handleClose();
    } else {
      this.props.movePage('/mypage', {
        sidx: 3,
      });
    }
    // window.opener = 'Self';
    // window.open('', '_parent', '');
    // window.close(); // 일반적인 현재 창 닫기
    // window.open('about:blank', '_self').self.close(); // IE에서 묻지 않고 창 닫기
  }

  setStateInitialize() {
    this.setState({
      figures: [],
      figuresMemo: [],
      numOfInstitution: [{ id: 'num-grid-1', country: '', department: '', affiliation: '', city: '' }],
      numOfAuthor: [
        {
          id: 'num-author-1',
          firstName: '',
          lastName: '',
          ino1: '',
          ino2: '',
          country: '',
          category: '',
          email: '',
          countryCode: '',
          phoneNumber: '',
        },
      ],
    });
    for (const [key, value] of Object.entries(this.state)) {
      if (
        key === 'presentationType' ||
        key === 'abstractTitle' ||
        key === 'selectPresentingAuthor' ||
        key === 'selectCorrespondingAuthor' ||
        key === 'purposeContent' ||
        key === 'methodsContent' ||
        key === 'resultsContent' ||
        key === 'conclusionContent' ||
        key === 'isAgree1' ||
        key === 'isAgree2'
      ) {
        if (value !== '') this.setState({ [key]: '' });
      }
      if (
        key === 'abstractTitleCnt' ||
        key === 'purposeParagraphCnt' ||
        key === 'purposeWordCnt' ||
        key === 'methodsParagraphCnt' ||
        key === 'methodsWordCnt' ||
        key === 'resultsParagraphCnt' ||
        key === 'resultsWordCnt' ||
        key === 'conclusionParagraphCnt' ||
        key === 'conclusionWordCnt'
      ) {
        this.setState({ [key]: 0 });
      }
      if (key === 'setOfInstitution' || key === 'setOfAuthor') {
        this.setState({ [key]: 1 });
      }
    }
  }

  render() {
    const { classes, theme, mode } = this.props;

    // console.log(this.state.purposeWordCnt);
    // console.log(this.state.methodsWordCnt);
    // console.log(this.state.resultsWordCnt);
    // console.log(this.state.conclusionWordCnt);

    const spacing = () => {
      if (!this.props.isAdmin) {
        return (
          <Grid item xs={8}>
            <div style={{ height: '20px' }} />
          </Grid>
        );
      }
    };

    let arrInstitution = [];
    for (let i = 0; i < 20; i++) arrInstitution.push(i + 1);

    return (
      <>
        <div>
          <Grid
            className={classes.root}
            item
            xs={12}
            style={
              this.props.isAdmin
                ? navigator.userAgent.indexOf('Trident') !== -1
                  ? { padding: 20, minWidth: '960px' }
                  : { padding: 20 }
                : { padding: 0 }
            }
          >
            <Card className={classes.card} variant="outlined">
              <CardContent>
                <Typography className={classes.title} gutterBottom>
                  Instruction
                </Typography>
                <Typography className={classes.body}>
                  - Submitter is responsible for typing errors.
                  <br />- The abstract must not exceed <span>250</span> words. Please do not include title, author, or institution
                  information in the abstract.
                  <br />- The character count only includes text in the BODY (Purpose, Methods, Results and Conclusion) of your abstract.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          {spacing()}
          <Grid
            item
            xs={12}
            style={
              this.props.isAdmin
                ? navigator.userAgent.indexOf('Trident') !== -1
                  ? { padding: 20, minWidth: '960px' }
                  : { padding: 20 }
                : { padding: 0 }
            }
          >
            <Typography align="right">
              Fields marked with an asterisk(<span className={classes.asteriskMark}>*</span>) are required.
            </Typography>
            <Card className={classes.topCard} variant="outlined">
              <CardContent>
                <Grid container direction={'column'} spacing={2}>
                  <Grid item style={{ display: 'flex' }}>
                    <div style={{ paddingRight: '1em' }}>
                      <FormControl component="fieldset">
                        <FormLabel component="legend" className={classes.formLabel}>
                          <span>*</span> Presentation Type
                        </FormLabel>
                        <RadioGroup
                          aria-label="type"
                          row
                          name="type"
                          value={this.state.presentationType}
                          onChange={(e) => {
                            this.handleState('presentationType', e.target.value);
                          }}
                        >
                          <FormControlLabel value="Oral" control={<Radio id="ptype" />} label="Oral" />
                          <FormControlLabel value="E-Poster" control={<Radio id="ptype" />} label="E-Poster" />
                        </RadioGroup>
                      </FormControl>
                    </div>
                    <div>
                      {this.state.presentationType && (
                        <FormControl component="fieldset" variant="outlined" size={'small'}>
                          <FormLabel component="legend" className={classes.formLabel}>
                            <span>*</span> Abstract Topic
                          </FormLabel>
                          <Select
                            required
                            displayEmpty
                            value={this.state.abstractTopic}
                            id={'atopic'}
                            onChange={(e) => this.handleState('abstractTopic', e.target.value)}
                          >
                            <MenuItem value={''}>Select</MenuItem>
                            {TOPIC_LIST.map((topic, idx) => {
                              return <MenuItem value={topic.value}>{topic.value}</MenuItem>;
                            })}
                          </Select>
                        </FormControl>
                      )}
                    </div>
                  </Grid>
                  {/* <Grid item>
                  </Grid> */}
                  <Grid item>
                    <FormLabel component="legend" className={classes.formLabel}>
                      <span>*</span> Abstract Title
                    </FormLabel>
                    <TextField
                      required
                      id="abstract-title-input"
                      fullWidth
                      variant="outlined"
                      size="small"
                      inputRef={this.titleRef}
                      onChange={this.handleChangeTitle}
                      value={this.state.abstractTitle}
                      helperText={`( ${this.state.abstractTitleCnt} ) / 30 words (The title should be less than 30 words.)`}
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
          {spacing()}
          <Grid
            item
            xs={12}
            style={
              this.props.isAdmin
                ? navigator.userAgent.indexOf('Trident') !== -1
                  ? { padding: 20, minWidth: '960px' }
                  : { padding: 20 }
                : { padding: 0 }
            }
          >
            <Typography className={classes.title} gutterBottom>
              Author Information
            </Typography>
            <Card className={classes.card} variant="outlined">
              <CardContent>
                <Typography className={classes.body}>
                  * If the author and co-author’s institution are the same, please select{' '}
                  <span style={{ color: 'blue' }}>'1' as the institution number</span> and click Insert button to enter all required
                  information.
                  <br />* If the author and co-author’s institution are different, please select{' '}
                  <span style={{ color: 'blue' }}>the number of institution</span> and click the Insert button to enter all required
                  information.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          {spacing()}
          <Grid
            item
            xs={12}
            style={
              this.props.isAdmin
                ? navigator.userAgent.indexOf('Trident') !== -1
                  ? { padding: 20, minWidth: '960px' }
                  : { padding: 20 }
                : { padding: 0 }
            }
          >
            <Typography align="right">
              Fields marked with an asterisk(<span className={classes.asteriskMark}>*</span>) are required.
            </Typography>
            <Card variant="outlined" className={classes.card}>
              <CardContent>
                <Grid container alignItems={'center'} spacing={1}>
                  <Grid item className={classes.cardText}>
                    Select the number of all institution
                  </Grid>
                  <Grid item>
                    <select
                      style={{ padding: 6 }}
                      id={'num-institution'}
                      value={this.state.setOfInstitution}
                      onChange={(e) => {
                        this.handleState('setOfInstitution', e.target.value);
                      }}
                    >
                      {arrInstitution.map((a) => {
                        return (
                          <option key={a} value={a}>
                            {a}
                          </option>
                        );
                      })}
                    </select>
                  </Grid>
                  <Grid item>
                    <Button size={'small'} color="primary" variant={'contained'} disableElevation onClick={this.setNumInstitution}>
                      ADD
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
          {spacing()}
          {this.addInstitution()}
          {spacing()}
          <Grid
            item
            xs={12}
            style={
              this.props.isAdmin
                ? navigator.userAgent.indexOf('Trident') !== -1
                  ? { padding: 20, minWidth: '960px' }
                  : { padding: 20 }
                : { padding: 0 }
            }
          >
            <Card variant="outlined" className={classes.card}>
              <CardContent>
                <Grid container alignItems={'center'} spacing={1}>
                  <Grid item className={classes.cardText}>
                    Select the number of all authors (including a presenting and corresponding author)
                  </Grid>
                  <Grid item>
                    <select
                      style={{ padding: 6 }}
                      id={'num-author'}
                      value={this.state.setOfAuthor}
                      onChange={(e) => {
                        this.handleState('setOfAuthor', e.target.value);
                      }}
                    >
                      {arrInstitution.map((a) => {
                        return (
                          <option key={a} value={a}>
                            {a}
                          </option>
                        );
                      })}
                    </select>
                  </Grid>
                  <Grid item>
                    <Button size="small" color="primary" variant={'contained'} disableElevation onClick={this.setNumAuthor}>
                      ADD
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
          {spacing()}
          {this.addAuthor()}
          {spacing()}
          <Grid
            item
            xs={12}
            style={
              this.props.isAdmin
                ? navigator.userAgent.indexOf('Trident') !== -1
                  ? { padding: 20, minWidth: '960px' }
                  : { padding: 20 }
                : { padding: 0 }
            }
          >
            <Card className={classes.topCard} variant="outlined">
              <CardContent>
                <div>
                  <h3>Presenting Author Information</h3>
                  <MaterialTable>
                    <TableBody>
                      <TableRow>
                        <TableCell component={'th'} width="20%">
                          <span>*</span>Name
                        </TableCell>
                        <TableCell>
                          <Grid container direction={'row'} justifyContent={'space-evenly'} spacing={1}>
                            <Grid item md={6} xs={12}>
                              <TextField
                                required
                                fullWidth
                                margin={'dense'}
                                placeholder="First Name"
                                variant="outlined"
                                onChange={(e) => this.handleChangeAuthorInfo(e, 'Presenting', 'firstName')}
                                value={this.getAuthorInfo('Presenting', 'firstName')}
                                id="presenting-first-name"
                              />
                            </Grid>
                            <Grid item md={6} xs={12}>
                              <TextField
                                required
                                fullWidth
                                margin={'dense'}
                                placeholder="Last Name(Family Name)"
                                variant="outlined"
                                onChange={(e) => this.handleChangeAuthorInfo(e, 'Presenting', 'lastName')}
                                value={this.getAuthorInfo('Presenting', 'lastName')}
                                id="presenting-last-name"
                              />
                            </Grid>
                          </Grid>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component={'th'} width="20%">
                          <span>*</span>Institution No.
                        </TableCell>
                        <TableCell>
                          <Grid container direction={'row'} spacing={1}>
                            <Grid item container xs={6} spacing={1}>
                              <Grid item xs={6}>
                                <FormControl variant="outlined" fullWidth size={'small'} className={this.props.classes.formControl}>
                                  <Select
                                    required
                                    displayEmpty
                                    id={'sel-institution-1'}
                                    value={this.getAuthorInfo('Presenting', 'ino1')}
                                    onChange={(e) => this.handleChangeAuthorInfo(e, 'Presenting', 'ino1')}
                                  >
                                    <MenuItem key={'n1'} value="">
                                      Select
                                    </MenuItem>
                                    {this.state.numOfInstitution.map((a, idx) => {
                                      return (
                                        <MenuItem key={a.id} value={a.id}>
                                          {1 + idx}
                                        </MenuItem>
                                      );
                                    })}
                                  </Select>
                                </FormControl>
                              </Grid>

                              <Grid item xs={6}>
                                <FormControl variant="outlined" fullWidth size={'small'} className={classes.formControl}>
                                  <Select
                                    displayEmpty
                                    id={'sel-institution-2'}
                                    value={this.getAuthorInfo('Presenting', 'ino2')}
                                    onChange={(e) => this.handleChangeAuthorInfo(e, 'Presenting', 'ino2')}
                                    disabled={this.state.numOfInstitution.length <= 1}
                                  >
                                    <MenuItem key={'n2'} value="">
                                      Select
                                    </MenuItem>
                                    {this.state.numOfInstitution.map((a, idx) => {
                                      return (
                                        <MenuItem key={a.id} value={a.id}>
                                          {1 + idx}
                                        </MenuItem>
                                      );
                                    })}
                                  </Select>
                                </FormControl>
                              </Grid>
                            </Grid>
                          </Grid>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component={'th'} width="20%">
                          <span>*</span>Country
                        </TableCell>
                        <TableCell>
                          <Grid container direction={'row'} spacing={1}>
                            <Grid item md={6} xs={12}>
                              <FormControl variant="outlined" fullWidth size={'small'} className={classes.formControl}>
                                <Select
                                  required
                                  displayEmpty
                                  labelId="country-label"
                                  value={this.getAuthorInfo('Presenting', 'country')}
                                  onChange={(e) => this.handleChangeAuthorInfo(e, 'Presenting', 'country')}
                                  id="presenting-country"
                                >
                                  <MenuItem value={''}>Select</MenuItem>
                                  {CountryList.map((country, cIdx) => {
                                    return (
                                      <MenuItem value={country.name} key={`country-select-item-${cIdx}`}>
                                        {country.name}
                                      </MenuItem>
                                    );
                                  })}
                                </Select>
                              </FormControl>
                            </Grid>
                          </Grid>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component={'th'} width="20%">
                          <span>*</span>Category
                        </TableCell>
                        <TableCell>
                          <Grid container direction={'row'} spacing={1}>
                            <Grid item xs={12}>
                              <RadioGroup
                                row
                                value={this.getAuthorInfo('Presenting', 'category')}
                                onChange={(e) => this.handleChangeAuthorInfo(e, 'Presenting', 'category')}
                              >
                                <FormControlLabel value={'Physician'} control={<Radio id="presenting-category" />} label="Physician" />
                                <FormControlLabel value={'Fellow'} control={<Radio />} label="Fellow" />
                                <FormControlLabel value={'Resident'} control={<Radio />} label="Resident" />
                                <FormControlLabel value={'Trainee'} control={<Radio />} label="Trainee" />
                              </RadioGroup>
                            </Grid>
                          </Grid>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component={'th'} width="20%">
                          <span>*</span>Email
                        </TableCell>
                        <TableCell>
                          <Grid container direction={'row'} spacing={1}>
                            <Grid item md={6} xs={12}>
                              <TextField
                                required
                                fullWidth
                                margin={'dense'}
                                variant="outlined"
                                id="presenting-email"
                                onChange={(e) => this.handleChangeAuthorInfo(e, 'Presenting', 'email')}
                                value={this.getAuthorInfo('Presenting', 'email')}
                              />
                            </Grid>
                          </Grid>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component={'th'} width="20%">
                          <span>*</span>Mobile
                        </TableCell>
                        <TableCell>
                          <Grid container direction={'row'} spacing={1}>
                            <Grid item md={6} xs={12}>
                              <div style={{ display: 'flex' }}>
                                <div style={{ textAlign: 'center' }}>
                                  <InputLabel htmlFor="presenting-country-code-input" className={classes.inputLabelText}>
                                    +Country Code
                                  </InputLabel>
                                  <TextField
                                    id="presenting-country-code-input"
                                    variant="outlined"
                                    fullWidth
                                    size={'small'}
                                    value={this.getAuthorInfo('Presenting', 'countryCode')}
                                    onChange={(e) => {
                                      this.handleChangeAuthorInfo(e, 'Presenting', 'countryCode');
                                    }}
                                  />
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                  <span style={{ fontSize: '1.5em', padding: '0 5px' }}>-</span>
                                </div>
                                <div style={{ textAlign: 'center' }}>
                                  <InputLabel htmlFor="presenting-phone-number-input" className={classes.inputLabelText}>
                                    Phone Number
                                  </InputLabel>
                                  <TextField
                                    id="presenting-phone-number-input"
                                    variant="outlined"
                                    fullWidth
                                    size={'small'}
                                    value={this.getAuthorInfo('Presenting', 'phoneNumber')}
                                    onChange={(e) => this.handleChangeNum(e, 'Presenting', 'phoneNumber')}
                                  />
                                </div>
                              </div>
                            </Grid>
                          </Grid>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </MaterialTable>
                </div>
                <div style={{ marginTop: theme.spacing(2) }}>
                  <h3>Corresponding Author Information</h3>
                  <MaterialTable>
                    <TableBody>
                      <TableRow>
                        <TableCell component={'th'} width="20%">
                          <span>*</span>Name
                        </TableCell>
                        <TableCell>
                          <Grid container direction={'row'} justifyContent={'space-evenly'} spacing={1}>
                            <Grid item md={6} xs={12}>
                              <TextField
                                required
                                fullWidth
                                margin={'dense'}
                                placeholder="First Name"
                                variant="outlined"
                                onChange={(e) => this.handleChangeAuthorInfo(e, 'Corresponding', 'firstName')}
                                value={this.getAuthorInfo('Corresponding', 'firstName')}
                                id="corresponding-first-name"
                              />
                            </Grid>
                            <Grid item md={6} xs={12}>
                              <TextField
                                required
                                fullWidth
                                margin={'dense'}
                                placeholder="Last Name(Family Name)"
                                variant="outlined"
                                onChange={(e) => this.handleChangeAuthorInfo(e, 'Corresponding', 'lastName')}
                                value={this.getAuthorInfo('Corresponding', 'lastName')}
                                id="corresponding-last-name"
                              />
                            </Grid>
                          </Grid>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component={'th'} width="20%">
                          <span>*</span>Institution No.
                        </TableCell>
                        <TableCell>
                          <Grid container direction={'row'} spacing={1}>
                            <Grid item container xs={6} spacing={1}>
                              <Grid item xs={6}>
                                <FormControl variant="outlined" fullWidth size={'small'} className={classes.formControl}>
                                  <Select
                                    required
                                    displayEmpty
                                    id={'sel-institution-1'}
                                    value={this.getAuthorInfo('Corresponding', 'ino1')}
                                    onChange={(e) => this.handleChangeAuthorInfo(e, 'Corresponding', 'ino1')}
                                  >
                                    <MenuItem key={'n1'} value="">
                                      Select
                                    </MenuItem>
                                    {this.state.numOfInstitution.map((a, idx) => {
                                      return (
                                        <MenuItem key={a.id} value={a.id}>
                                          {1 + idx}
                                        </MenuItem>
                                      );
                                    })}
                                  </Select>
                                </FormControl>
                              </Grid>

                              <Grid item xs={6}>
                                <FormControl variant="outlined" fullWidth size={'small'} className={classes.formControl}>
                                  <Select
                                    displayEmpty
                                    id={'sel-institution-2'}
                                    value={this.getAuthorInfo('Corresponding', 'ino2')}
                                    onChange={(e) => this.handleChangeAuthorInfo(e, 'Corresponding', 'ino2')}
                                    disabled={this.state.numOfInstitution.length <= 1}
                                  >
                                    <MenuItem key={'n2'} value="">
                                      Select
                                    </MenuItem>
                                    {this.state.numOfInstitution.map((a, idx) => {
                                      return (
                                        <MenuItem key={a.id} value={a.id}>
                                          {1 + idx}
                                        </MenuItem>
                                      );
                                    })}
                                  </Select>
                                </FormControl>
                              </Grid>
                            </Grid>
                          </Grid>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component={'th'} width="20%">
                          <span>*</span>Country
                        </TableCell>
                        <TableCell>
                          <Grid container direction={'row'} spacing={1}>
                            <Grid item md={6} xs={12}>
                              <FormControl variant="outlined" fullWidth size={'small'} className={classes.formControl}>
                                <Select
                                  required
                                  displayEmpty
                                  labelId="country-label"
                                  value={this.getAuthorInfo('Corresponding', 'country')}
                                  onChange={(e) => this.handleChangeAuthorInfo(e, 'Corresponding', 'country')}
                                  id="corresponding-country"
                                >
                                  <MenuItem value={''}>Select</MenuItem>
                                  {CountryList.map((country, cIdx) => {
                                    return (
                                      <MenuItem value={country.name} key={`country-select-item-${cIdx}`}>
                                        {country.name}
                                      </MenuItem>
                                    );
                                  })}
                                </Select>
                              </FormControl>
                            </Grid>
                          </Grid>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component={'th'} width="20%">
                          <span>*</span>Category
                        </TableCell>
                        <TableCell>
                          <Grid container direction={'row'} spacing={1}>
                            <Grid item xs={12}>
                              <RadioGroup
                                row
                                value={this.getAuthorInfo('Corresponding', 'category')}
                                onChange={(e) => this.handleChangeAuthorInfo(e, 'Corresponding', 'category')}
                              >
                                <FormControlLabel value={'Physician'} control={<Radio id="corresponding-category" />} label="Physician" />
                                <FormControlLabel value={'Fellow'} control={<Radio />} label="Fellow" />
                                <FormControlLabel value={'Resident'} control={<Radio />} label="Resident" />
                                <FormControlLabel value={'Trainee'} control={<Radio />} label="Trainee" />
                              </RadioGroup>
                            </Grid>
                          </Grid>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component={'th'} width="20%">
                          <span>*</span>Email
                        </TableCell>
                        <TableCell>
                          <Grid container direction={'row'} spacing={1}>
                            <Grid item md={6} xs={12}>
                              <TextField
                                required
                                fullWidth
                                margin={'dense'}
                                variant="outlined"
                                id="corresponding-email"
                                onChange={(e) => this.handleChangeAuthorInfo(e, 'Corresponding', 'email')}
                                value={this.getAuthorInfo('Corresponding', 'email')}
                              />
                            </Grid>
                          </Grid>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component={'th'} width="20%">
                          <span>*</span>Mobile
                        </TableCell>
                        <TableCell>
                          <Grid container direction={'row'} spacing={1}>
                            <Grid item md={6} xs={12}>
                              <div style={{ display: 'flex' }}>
                                <div style={{ textAlign: 'center' }}>
                                  <InputLabel htmlFor="corresponding-country-code-input" className={classes.inputLabelText}>
                                    +Country Code
                                  </InputLabel>
                                  <TextField
                                    id="corresponding-country-code-input"
                                    variant="outlined"
                                    fullWidth
                                    size={'small'}
                                    value={this.getAuthorInfo('Corresponding', 'countryCode')}
                                    onChange={(e) => this.handleChangeAuthorInfo(e, 'Corresponding', 'countryCode')}
                                  />
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                  <span style={{ fontSize: '1.5em', padding: '0 5px' }}>-</span>
                                </div>
                                <div style={{ textAlign: 'center' }}>
                                  <InputLabel htmlFor="corresponding-phone-number-input" className={classes.inputLabelText}>
                                    Phone Number
                                  </InputLabel>
                                  <TextField
                                    id="corresponding-phone-number-input"
                                    variant="outlined"
                                    fullWidth
                                    size={'small'}
                                    value={this.getAuthorInfo('Corresponding', 'phoneNumber')}
                                    onChange={(e) => this.handleChangeNum(e, 'Corresponding', 'phoneNumber')}
                                  />
                                </div>
                              </div>
                            </Grid>
                          </Grid>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </MaterialTable>
                </div>
              </CardContent>
            </Card>
          </Grid>
          {spacing()}
          <Grid
            item
            xs={12}
            style={
              this.props.isAdmin
                ? navigator.userAgent.indexOf('Trident') !== -1
                  ? { padding: 20, minWidth: '960px' }
                  : { padding: 20 }
                : { padding: 0 }
            }
          >
            <div style={{ display: 'flex', alignItems: 'baseline' }}>
              <Typography className={classes.title} gutterBottom style={mode === 'modify' ? { width: 'auto' } : {}}>
                Abstract Information{' '}
              </Typography>
              <Typography style={{ fontSize: '1em', marginLeft: '1em' }}>
                ※ The abstract must not exceed 250 words. (All abstracts words :{' '}
                {this.state.purposeWordCnt + this.state.methodsWordCnt + this.state.resultsWordCnt + this.state.conclusionWordCnt} / 250)
              </Typography>
            </div>

            <div style={{ width: 'fit-content', padding: '10px 0' }}>
              <Typography style={{ color: 'red' }}>
                When using the hospital Internet, abstract text writing function may not be available due to a internet firewall blocking
                it.
                <br /> In this case, please temporarily save the content other than the abstract text then connect to another Internet, fill
                out the abstract text and submit it.
              </Typography>
            </div>
            {this.state.loaded && (
              <Paper variant={'outlined'} className={classes.paper}>
                <TableContainer>
                  <MaterialTable>
                    <TableBody>
                      <TableRow>
                        <TableCell component={'th'} width="25%">
                          <span className={classes.asteriskMark}>*</span> Purpose
                        </TableCell>
                        <TableCell width="75%">
                          <Editor
                            data={this.state.purposeContent ? this.state.purposeContent : ''}
                            paragraphCnt={this.state.purposeParagraphCnt}
                            wordCnt={this.state.purposeWordCnt}
                            delayEvent={this.delayEvent}
                            type="purpose"
                          />
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component={'th'} width="25%">
                          <span className={classes.asteriskMark}>*</span> Methods
                        </TableCell>
                        <TableCell width="75%">
                          <Editor
                            data={this.state.methodsContent ? this.state.methodsContent : ''}
                            paragraphCnt={this.state.methodsParagraphCnt}
                            wordCnt={this.state.methodsWordCnt}
                            delayEvent={this.delayEvent}
                            type="methods"
                          />
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component={'th'} width="25%">
                          <span className={classes.asteriskMark}>*</span> Results
                        </TableCell>
                        <TableCell width="75%">
                          <Editor
                            data={this.state.resultsContent ? this.state.resultsContent : ''}
                            paragraphCnt={this.state.resultsParagraphCnt}
                            wordCnt={this.state.resultsWordCnt}
                            delayEvent={this.delayEvent}
                            type="results"
                          />
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component={'th'} width="25%">
                          <span className={classes.asteriskMark}>*</span> Conclusion
                        </TableCell>
                        <TableCell width="75%">
                          <Editor
                            data={this.state.conclusionContent ? this.state.conclusionContent : ''}
                            paragraphCnt={this.state.conclusionParagraphCnt}
                            wordCnt={this.state.conclusionWordCnt}
                            delayEvent={this.delayEvent}
                            type="conclusion"
                          />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </MaterialTable>
                </TableContainer>
              </Paper>
            )}
          </Grid>
          {spacing()}
          <Grid
            item
            xs={12}
            style={
              this.props.isAdmin
                ? navigator.userAgent.indexOf('Trident') !== -1
                  ? { padding: 20, minWidth: '960px' }
                  : { padding: 20 }
                : { padding: 0 }
            }
          >
            <FiguresUploadForm
              setOfFigures={this.state.setOfFigures}
              handleChangeImg={this.handleChangeImg}
              clickUploadImg={this.clickUploadImg}
              deleteImg={this.deleteImg.bind(this)}
              handleFigureMemo={this.handleFigureMemo}
              figures={this.state.figures}
              figuresMemo={this.state.figuresMemo}
              mode={mode}
            />
          </Grid>
          {spacing()}
          <Grid
            item
            xs={12}
            style={
              this.props.isAdmin
                ? navigator.userAgent.indexOf('Trident') !== -1
                  ? { padding: 20, minWidth: '960px' }
                  : { padding: 20 }
                : { padding: 0 }
            }
          >
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell component={'th'} style={{ textAlign: 'left' }} /* width={'80%'} */>
                    <span className={classes.asteriskMark}>*</span> Do you agree on changing your presentation type between oral
                    presentation and E-poster after abstract acceptance?
                  </TableCell>
                  <TableCell /* width={'20%'} */>
                    <RadioGroup
                      row
                      value={this.state.isAgree1}
                      onChange={(e) => {
                        this.handleState('isAgree1', e.target.value);
                      }}
                    >
                      <FormControlLabel value="agree" control={<Radio id="is-agree-1" />} label="Yes" />
                      <FormControlLabel value="disagree" control={<Radio id="is-agree-1" />} label="No" />
                    </RadioGroup>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component={'th'} style={{ textAlign: 'left' }} /* width={'80%'} */>
                    <span className={classes.asteriskMark}>*</span> Copyright Agreement
                  </TableCell>
                  <TableCell /* width={'20%'} */>
                    <RadioGroup
                      row
                      value={this.state.isAgree2}
                      onChange={(e) => {
                        this.handleState('isAgree2', e.target.value);
                      }}
                    >
                      <FormControlLabel value="agree" control={<Radio id="is-agree-2" />} label="I agree" />
                      <FormControlLabel value="disagree" control={<Radio id="is-agree-2" />} label="I don't agree" />
                    </RadioGroup>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Grid>
          {this.state.isAdmin && (
            <Grid
              item
              xs={12}
              style={
                this.props.isAdmin
                  ? navigator.userAgent.indexOf('Trident') !== -1
                    ? { padding: 20, minWidth: '960px' }
                    : { padding: 20 }
                  : { padding: 0 }
              }
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'baseline',
                  marginTop: 40,
                  marginBottom: 20,
                  borderBottom: `2px solid ${this.props.theme.palette.primary.main}`,
                }}
              >
                <Typography className={classes.title} gutterBottom style={mode === 'modify' ? { width: 'auto' } : {}}>
                  Admin Memo
                </Typography>
              </div>
              <TextareaAutosize
                style={{ width: '100%', padding: 20 }}
                rows={10}
                value={this.state.memo}
                onChange={(e) => this.setState({ memo: e.target.value })}
              />
            </Grid>
          )}
          <Grid
            item
            xs={12}
            style={
              this.props.isAdmin
                ? navigator.userAgent.indexOf('Trident') !== -1
                  ? { padding: 20, minWidth: '960px' }
                  : { padding: 20 }
                : { padding: theme.spacing(4, 0) }
            }
          >
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <ConfirmButton
                color="primary"
                onClick={() => {
                  if (this.props.isAdmin) {
                    // swal('수정');
                    this.onSubmit();
                  } else {
                    this.onSubmit();
                    // swal(
                    //   // 'Abstract Submission is closed.',
                    //   'PRS KOREA 2022 사무국으로 문의하여 주시기 바랍니다. Please request to PRS KOREA 2022 Secretariat.',
                    //   '',
                    //   <div>
                    //     <span style={{ fontSize: 27, fontWeight: 'bold' }}>Abstract Submission is closed.</span>
                    //     <br />
                    //     <br />
                    //     <span>PRS KOREA 2022 사무국으로 문의하여 주시기 바랍니다.</span>
                    //     <br />
                    //     <span>Please request to PRS KOREA 2022 Secretariat.</span>
                    //   </div>,

                    // );
                  }
                }}
              >
                {mode === 'write' ||
                this.props.isRegister ||
                (this.props.isMypage && this.props.infoData && this.props.infoData.status !== 'Complete')
                  ? 'Temporary Save & Preview'
                  : 'Modify'}
              </ConfirmButton>
              {/* {this.props.isRegister && (
              <ConfirmButton color="primary" onClick={() => this.onSubmit()}>
                Save
              </ConfirmButton>
            )} */}
              <div style={{ width: '20px' }} />
              <ConfirmButton
                onClick={() => {
                  if (mode === 'modify') {
                    this.closeWindow();
                  } else if (mode === 'write') {
                    this.props.moveBackPage();
                  }
                }}
              >
                Cancel
              </ConfirmButton>
            </div>
          </Grid>
        </div>
        {this.state.isSubmitting && (
          <div style={{ position: 'fixed', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}>
            <CircularProgress size={100} thickness={5} style={{ color: theme.palette.secondary.point }} />
          </div>
        )}
      </>
    );
  }
}

export default withStyles(styles, { withTheme: true })(FreePaperSubmissionForm);
